import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataModelComponent } from '../../../../models/data.model.component';
import { SubCategorias, ISubCategorias } from '../../../../models/subCategorias.model';
import { DadosService } from '../../db/dados.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-sub-categorias',
  templateUrl: './sub-categorias.component.html',
  styleUrls: ['./sub-categorias.component.css']
})
export class SubCategoriasComponent extends DataModelComponent<ISubCategorias> implements OnInit {
  dataSource: Array<any> = [];
  dataClass: SubCategorias;
  dataEvent: Subscription;
  @ViewChild('grid') grid: MatDataGridComponent;

  categoria: Number;
  categoriaItem:any;
  
  colunas = [{ field: "codigo", text: "Código" },
  { field: "nome", text: "Nome" },
  { field: "info", text: "Informações" }];


  ngOnDestroy(){
    this.dataEvent.unsubscribe();
  }

  doPostItem(event){
    if (this.item.categoria==null)
       this.item.categoria = Number(this.categoria);
    this.item.categoria =Number(this.item.categoria);  
    this.item.codigo =Number(this.item.codigo);
    this.dataClass.post(this.item);
    super.doPostItem(event);
  }

  doEditItem(event){
    super.doEditItem(event);
    if (this.inserting)
      this.doGerarCodigo();
  }

  doCheckFilter(x:boolean){
    this.dataClass.verInativo = this.grid.checkFilterValue;
  }




  constructor(private db:AngularFirestore, private router: ActivatedRoute, private dados: DadosService) {
    super({
      codigo: new FormControl(),
      nome: new FormControl(),
      info: new FormControl(),
      inativo: new FormControl(false),
    }
    );
    dados.init();
  }

  ngOnInit() {

    this.categoria = this.router.snapshot.params.categoria;
 
 
    this.dados.getCategoria(this.categoria, r => {
      console.log(r);
      this.categoriaItem = r;
    });

    this.dataClass = new SubCategorias(this.db, 0);
    this.dataEvent = this.dataClass.changedEvent.subscribe(
      d => {
        console.log(d);
        this.dataSource = d.sort(function(a:any,b:any) {return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0);} );
      });
    this.dataClass.categoria = this.categoria;
    this.dataClass.verInativo = false;

  }
  getFilterAttrib(){
    return 'ver inativos';
  }

  doGerarCodigo(){
    this.dataClass.gerarNovoCodigo(this.categoria, r=>{
      this.item.codigo = r.valor;
    })
  }

}
